module.exports = __webpack_public_path__ + "static/img/10.e1b69a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/10.jpg
// module id = 35d9
// module chunks = 18